@if (isLoadingServices()) {
  <div class="mt-6 animate-pulse" role="status" aria-label="Loading services">
    <div class="mb-2 h-4 w-24 rounded bg-gray-200"></div>
    <div class="h-12 w-full rounded bg-gray-200"></div>
  </div>
} @else if (serviceOptions().length > 0) {
  <div [formGroup]="formRef" class="mt-6">
    <label class="comcast-input-label" for="service-trigger">
      Service
      @if (isServiceRequired) {
        <span class="comcast-required-marker" aria-hidden="true">*</span>
      } @else {
        <span class="text-brand-muted font-normal">(optional)</span>
      }
    </label>

    <div class="relative mt-2">
      <button
        id="service-trigger"
        type="button"
        class="comcast-select-trigger"
        [class.comcast-select-trigger--open]="isServiceDropdownOpen()"
        [class.comcast-select-trigger--filled]="!!selectedService"
        [class.comcast-input-invalid]="inlineErrors.service"
        [attr.aria-expanded]="isServiceDropdownOpen()"
        aria-haspopup="listbox"
        aria-controls="service-listbox"
        [attr.aria-required]="isServiceRequired"
        [attr.aria-invalid]="!!inlineErrors.service"
        [attr.aria-describedby]="inlineErrors.service ? 'service-error' : null"
        (click)="toggleServiceDropdown($event)"
      >
        @if (selectedService) {
          <div class="flex flex-col items-start text-left">
            <span class="font-lato text-base leading-tight">
              {{ selectedService.Z_Location__r?.Name ?? selectedService.Name }}
            </span>
            <span class="font-lato text-sm">
              {{ selectedService.Name }}
              @if (selectedService.RecordType?.Name) {
                · {{ selectedService.RecordType.Name }}
              }
            </span>
          </div>
        } @else {
          <span class="text-brand-muted">Please select a service</span>
        }
        <mat-icon class="comcast-select-icon" aria-hidden="true">
          {{ isServiceDropdownOpen() ? 'arrow_drop_up' : 'arrow_drop_down' }}
        </mat-icon>
      </button>

      @if (isServiceDropdownOpen()) {
        <!-- a11y listbox pattern: docs/accessibility/custom-listbox.md -->
        <div
          id="service-listbox"
          class="comcast-select-panel comcast-select-panel--open"
          role="listbox"
          aria-label="Services"
          (click)="$event.stopPropagation()"
        >
          <div class="comcast-select-search">
            <mat-icon class="comcast-select-search-icon" aria-hidden="true"
              >search</mat-icon
            >
            <input
              type="text"
              placeholder="Search by address or NIT..."
              aria-label="Search services by address or NIT"
              [value]="serviceSearchTerm()"
              (input)="onSearchInput($event)"
              class="comcast-select-search-input"
              appAutofocus
            />
          </div>
          <div class="comcast-select-options">
            @for (service of filteredServices; track service.Id) {
              <div
                class="comcast-select-option flex flex-col items-start"
                role="option"
                tabindex="0"
                [attr.aria-selected]="formRef.value.service === service.Id"
                [class.comcast-select-option--selected]="
                  formRef.value.service === service.Id
                "
                (click)="selectService(service, $event)"
                (keydown.enter)="selectService(service, $event)"
                (keydown.space)="selectService(service, $event)"
              >
                <span class="leading-tight">
                  {{ service.Z_Location__r?.Name ?? service.Name }}
                </span>
                <span class="text-sm">
                  {{ service.Name }}
                  @if (service.RecordType?.Name) {
                    · {{ service.RecordType.Name }}
                  }
                </span>
              </div>
            }
            @if (!filteredServices.length) {
              <div
                class="comcast-select-empty"
                role="option"
                aria-disabled="true"
              >
                No results found
              </div>
            }
          </div>
        </div>
      }
    </div>

    @if (inlineErrors.service) {
      <div id="service-error" class="comcast-validation-error" role="alert">
        Please select a service
      </div>
    }

    <ng-container *ngxPermissionsOnly="Permission.MANAGED_SECURITY">
      <div
        class="mt-3 flex items-start gap-3 rounded border border-blue-700/30 bg-blue-700/5 p-3"
      >
        <mat-icon
          fontSet="material-icons-outlined"
          class="!flex !h-5 !w-5 shrink-0 !items-center !justify-center !text-xl text-blue-700"
          aria-hidden="true"
        >
          security
        </mat-icon>
        <div class="flex flex-col gap-1">
          <span class="font-lato text-sm font-semibold text-black"
            >Have a Managed Security service?</span
          >
          <span class="font-lato text-brand-text text-sm">
            Managed Security support is handled through our partner portal.
          </span>
          <a
            [href]="iscUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="comcast-inline-link mt-1"
            aria-label="Open partner portal (opens in new tab)"
          >
            Open partner portal
            <mat-icon
              class="!flex !h-4 !w-4 !items-center !justify-center !text-sm"
              aria-hidden="true"
              >open_in_new</mat-icon
            >
          </a>
        </div>
      </div>
    </ng-container>
  </div>
}
